export default {
      id: "move-usage",
      viewBox: "0 0 13.275 13.261",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#move",
      toString: function () {
        return this.url;
      }
    }